import {version} from "../../package.json";
import type {FirebaseOptions} from 'firebase/app';
import type {AccountOAuthConfig} from '../app/supabase.env';

/**
 * Build-time defaults. Runtime API hosts come from RegionService
 * (`app.env.config.ts`): LOCAL → 127.0.0.1:27000, DEV → api-dev, US/CN → prod.
 * Keep apiPrefix here only as a fallback for any non-region callers.
 */
export const environment = {
  production: false,
  tracingEnabled: false,
  version: version,
  name: 'development',
  appId: '6a1eaa73-0033-48b8-a73f-101d039c323f',
  storageVersion: 'v3-supabase',
  /**
   * OAuth IdP + client must match the Auth project selected by region
   * (LOCAL/DEV → dev; US/EU/CN → prod). Local builds can switch either way.
   */
  accountOAuth: {
    prod: {
      accountAppUrl: "https://account.mangopower.com",
      oauthClientId: "5c7fbc2e-ebf7-47e2-b1d5-d198f44da519",
    },
    dev: {
      accountAppUrl: "https://account-dev.mangopower.com",
      oauthClientId: "10756681-e969-441a-8d2c-b71d82f0ba32",
    },
  } satisfies Record<'prod' | 'dev', AccountOAuthConfig>,
  /** @deprecated Prefer resolveAccountOAuthConfig(region); kept as DEV Auth default. */
  accountAppUrl: "https://account-dev.mangopower.com",
  /** @deprecated Prefer resolveAccountOAuthConfig(region); kept as DEV Auth default. */
  oauthClientId: "10756681-e969-441a-8d2c-b71d82f0ba32",
  apiPrefix: {
    base: 'http://127.0.0.1:27000/v3',
    ispV4: 'http://127.0.0.1:27000/v4/installer-portal',
  },
  firebaseConfig: {} as FirebaseOptions
};
